import { createStore } from "vuex";

import auth from "./modules/auth";
import platform from "./modules/platform";
import menu from "./modules/menu";
import router from "./modules/router";
import enterprise from "./modules/enterprise";

export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    platform,
    menu,
    router,
    enterprise,
  },
});
